<template>
  <div class="filters-container">
    <div class="filter filter--search">
      <label class="text-muted hidden-sm" for="search-input">Search</label>
      <SearchInput
        :hide-button="true"
        :initial-query="initialQuery"
        @query:changed="handleQueryChanged" />
    </div>
    <div
      class="filter"
      v-for="(filter, index) of filtersArray"
      :key="index">
      <span class="filter-label text-muted">
        {{ filter.label }}
      </span>
      <A11yDropdown
        :dropdown-props="{
          ref:'dropdown',
          class:'btn-dropdown',
          disabled: ((filter.urlParam === 'barrier' && !subject) || (filter.options && filter.options.length === 0))
        }"
        :button-props="{
          class: 'btn btn-default dropdown-toggle',
          'aria-label': filter.label,
          disabled: ((filter.urlParam === 'barrier' && !subject) || (filter.options && filter.options.length === 0))
        }"
        :dom-attributes="{
          role: 'listbox',
        }"
      >
        <template slot="button-contents">
          {{ filter.valueLabel || filter.emptyText }} <span class="caret" v-if="filter.options && filter.options.length > 0"/>
        </template>
        <template v-if="filter.urlParam !== 'grades'" slot="dropdown-items">
          <li v-if="loadingOptions" class="dropdown-menu-loading"><i class="fa fa-circle-o-notch fa-spin"/></li>
          <template v-if="!loadingOptions">
            <li class="dropdown-item"><a role="button" @click="updateFilterSelection(filter.urlParam, undefined)">{{ filter.emptyText }}</a></li>
            <li class="divider"/>
          </template>
          <li
            class="dropdown-item"
            v-for="option in filter.options"
            :key="option.value"><a role="button" @click="updateFilterSelection(filter.urlParam, option.value || option)">{{ option.label || option }}</a></li>
        </template>
        <template v-else slot="dropdown-items">
          <template v-if="filter.value">
            <li class="dropdown-item"><a role="button" @click="updateFilterSelection(filter.urlParam, undefined)">{{ filter.emptyText }}</a></li>
            <li class="divider"/>
          </template>
          <li
            class="dropdown-item"
            v-for="option in filter.options"
            :key="option.label"><a role="button" @click="updateFilterSelection(filter.urlParam, option.value)">{{ option.label }}</a></li>
        </template>
      </A11yDropdown>
    </div>

    <div class="nav-link text-right">
      <router-link :to="{name: 'StrategyIndex'}">View strategy index</router-link>
    </div>
  </div>
</template>

<script>
import { getStrategyTags } from '@/api/strategies'
import {
  filterProps,
  emptyTextOptions,
  strategyFiltersDataMixin
} from '@/components/strategies/strategy_filters_util'
import A11yDropdown from '@/components/A11yDropdown'
import SearchInput from '@/components/search/SearchInput'

export default {
  name: 'BrowseStrategiesFilters',
  components: {
    SearchInput,
    A11yDropdown
  },
  props: {
    ...filterProps,
    initialQuery: {
      type: String,
      default: ''
    }
  },
  mixins: [strategyFiltersDataMixin],
  computed: {
    filtersArray() {
      return [
        {
          label: 'Subject',
          urlParam: 'subject',
          value: this.subject,
          valueLabel: this.getStrategySubjectLabelFromValue(this.subject),
          emptyText: emptyTextOptions.subject,
          options: this.subjectOptions,
          show: this.shouldShowParam('subject')
        },
        {
          label: 'Barrier',
          urlParam: 'barrier',
          value: this.barrier,
          valueLabel: this.barrier,
          emptyText: emptyTextOptions.barrier(this.getStrategySubjectLabelFromValue(this.subject)),
          options: this.barrierOptions,
          show: this.shouldShowParam('barrier')
        },
        {
          label: 'Grades',
          urlParam: 'grades',
          value: this.grades,
          valueLabel: this.gradeLabel,
          emptyText: emptyTextOptions.grades,
          options: this.gradeOptions,
          show: this.shouldShowParam('grades')
        },
        {
          label: 'Type of Instruction',
          urlParam: 'teachingType',
          value: this.teachingType,
          valueLabel: this.teachingType,
          emptyText: emptyTextOptions.teachingType,
          options: this.teachingTypeOptions,
          show: this.shouldShowParam('teachingType')
        },
        {
          label: 'Instructional Setting',
          urlParam: 'setting',
          value: this.setting,
          valueLabel: this.setting,
          emptyText: emptyTextOptions.setting,
          options: this.settingOptions,
          show: this.shouldShowParam('setting')
        }
      ].filter(filter => filter.show)
    }
  },
  methods: {
    handleQueryChanged(query) {
      this.updateFilterSelection('query', query)
    },
    updateFilterSelection(field, value) {
      this.$emit('updateSelection', { field, value })
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
@import '~@/components/strategies/common.less';

.filters-container {
  background: @libraryColorBg;
  border: 1px solid #ccc;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;

  .filter {
    &.filter--search {
      flex: 2 1;

      @media (max-width: @screen-sm-max) {
        width: 100%;
        flex: none;
      }
    }
    padding: 12px;

    label, .filter-label {
      display: block;
      margin-bottom: 5px;
      font-weight: 700;
      font-size: 12px;

      a {
        font-weight: normal;
        display: inline-block;
        margin-left: 4px;
      }
    }

    .btn.btn-muted {
      &:focus {
        color: var(--gray-default);
      }
      color: var(--gray-default);
    }
  }

  .nav-link {
    flex: 1 1;
    padding: 12px;
    align-self: center;
  }
}
</style>
